import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const dominios = {
	state: {
		dominios: '',
		interesesCV: [],
		programas: [],
		titulacionesEmpresa: '',
		motivosRechazo: '',
		aniosForo: [],
		tiposNivelFormativoSNE: '',
		rangosDeCreditos: [],
		tiposContactoEmpresa:[],
		tiposIdentificacionDatosFacturacionCentro:[]
	},
	getters: {
		getDominio: state => {
			return (value) => {
				return state.dominios[value];
			}
		},
		getDominios: state => state.dominios,
		getInteresesCV: state => state.interesesCV,
		getTiposContactoEmpresa: state => state.tiposContactoEmpresa,
		getTiposIdentificacionDatosFacturacionCentro: state => state.tiposIdentificacionDatosFacturacionCentro,
		getProgramas: state => state.programas,
		getPaises: state => {
			if (!!state.dominios.paises) {
				let paises = Object.entries(state.dominios.paises);
				return paises.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getDominiosOrder: state => {
			let dominios = new Object();

			if (!!state.dominios) {
				Object.entries(state.dominios).forEach(d => {
					if (!!d[1]) {
						dominios[d[0]] = Object.entries(d[1]).sort(function (p1, p2) {
							return (p1[1] < p2[1]) ? -1 : 1;
						});
					}
				});
			}

			return dominios;

		},
		getProvincias: state => {
			if (!!state.dominios.provincias) {
				let provincias = Object.entries(state.dominios.provincias);
				return provincias.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getAreasFuncionales: state => {
			if (!!state.dominios.areasFuncionales) {

				let areasFuncionales = Object.entries(state.dominios.areasFuncionales);

				let otrosString = ['otras', 'otros'];

				//COPIA DE OTROS
				let otros = areasFuncionales.filter(e => { return (otrosString.some(s => s.toLowerCase() == e[1].toLowerCase())) })[0];

				//SACO EL CAMPO "OTROS";
				areasFuncionales = areasFuncionales.filter(e => { return !(otrosString.some(s => s.toLowerCase() == e[1].toLowerCase())) });


				areasFuncionales = areasFuncionales.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});

				if (!!otros) {
					areasFuncionales.push(otros);
				}

				return areasFuncionales;

			}
		},
		getSectoresActividad: state => {
			if (!!state.dominios.sectoresActividad) {
				let sectoresActividad = Object.entries(state.dominios.sectoresActividad);
				return sectoresActividad.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getTiposContrato: state => {
			if (!!state.dominios.tiposContrato) {
				let tiposContrato = Object.entries(state.dominios.tiposContrato);
				return tiposContrato.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getTiposContratoOfertasPracticas: state => state.dominios.tiposContratoOfertaPracticas,

		getTiposDocumentoAlumnoPracticas: state => {
			if (!!state.dominios.tiposDocumentoAlumnoPracticas) {
				let tiposDocumentoAlumnoPracticas = Object.entries(state.dominios.tiposDocumentoAlumnoPracticas);
				return tiposDocumentoAlumnoPracticas.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getEstadosCandidaturaAlumno: state => {
			if (!!state.dominios.estadosCandidaturasAlumno) {
				let tiposestadosCandidaturasAlumno = Object.entries(state.dominios.estadosCandidaturasAlumno);
				return tiposestadosCandidaturasAlumno.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getTitulacionesEmpresa: state => {
			if (!!state.titulacionesEmpresa) {
				return state.titulacionesEmpresa;
			}
		},
		getmotivosRechazo: state => {
			if (!!state.motivosRechazo) {
				return state.motivosRechazo;
			}
		},
		getLocalidades: state => {

			return (idProvincia) => {

				let localidades;

				if (!!state.dominios.localidades) {
					localidades = state.dominios.localidades.filter(l => l.idProvincia == idProvincia);
					localidades = localidades.sort(function (p1, p2) {
						return (p1.descripcion < p2.descripcion) ? -1 : 1;
					});
				}



				return localidades

			}
		},
		getAmbitos: state => {

			let ambitos;

			if (!!state.dominios.ambitos) {
				ambitos = Object.values(state.dominios.ambitos).sort(function (p1, p2) {
					return (p1.ambitoEstudo < p2.ambitoEstudo) ? -1 : 1;
				});
			}
			return ambitos

		},
		getEspecialidades: state => {

			let especialidades = new Array();

			if (!!state.dominios && !!state.dominios.ambitos) {
				Object.values(state.dominios.ambitos).forEach(e => {
					Object.entries(e.especialidadesAmbitoEstudio).forEach(especialidad => {
						especialidades.push(especialidad);
					});
				})
			}

			especialidades.sort(function (p1, p2) {
				return (p1[1].normalize("NFD").replace(/[\u0300-\u036f]/g, "") < p2[1].normalize("NFD").replace(/[\u0300-\u036f]/g, "")) ? -1 : 1;
			});

			return especialidades;
		},
		getAniosForo: state => state.aniosForo,
		getTipoContactoEmpresa: state => {

			let tipos;


			if (!!state.dominios.tiposContacoEmpresa) {
				tipos = Object.entries(state.dominios.tiposContacoEmpresa).sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}

			return tipos;

		},
		getIsla(state) {
			return (id) => {
				let isla;
				if (state.dominios && state.dominios.islas.length != 0) {
					isla = state.dominios.islas.filter(isla => isla.idIsla == id)[0];
				}
				return isla;
			};
		},

	},
	actions: {
		requestDominios: ({ commit, getters, dispatch }) => {

			axios.get(`/api/Dominios/dominios/${getters.getLanguage}`).then(response => {
				(response.data.status == 0) ? commit('setDominios', response.data.datos) : '';
				dispatch('requestDominiosList');
			})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
		},
		requestDominiosList: ({ commit, getters, dispatch }) => {

			let list = [
				'tiposContacoEmpresa',
				'localidades',
				'tiposVia',
				'titulaciones',
				'ProgramasInformaticos',
				'competenciasfesionales',
				'tipoEstanciasExtranjero',
				'nivelesProgramasInformaticos',
				'tipoMotivoCambioEstadoCandidatura',
				'tiposFormacionAcademica',
				'tiposDocumentoIdentidad',
				'tiposContratoExperiencias',
				'tiposNivelesTitulacion',
				'subtiposContratoExperiencias',
				'actividadesrofesionales',
				'ambitosEstudio',
				'ragosFacturacion',
				'numeroDeEmpleados',
				'tipoOpcionPublicacionOferta',
				'TagsInteresAlumno',
				'rangosDeCreditos',
				'tiposNivelFormativoSNE',
				'estadosCandidaturasDestinoParaEmpresa'

			];

			axios.get(`/api/Dominios/dominiosList/${getters.getLanguage}`).then(response => {

				if (response.data.datos.length != 0) {
					if (response.data.status == 0) {
						list.forEach(el => {
							let data = [el, response.data.datos[el]];
							(response.data.status == 0) ? commit('setDominiosList', data) : '';
						});					
					} else{
						'';
					}
				}
			}).catch(function (error) { });
		},
		requestIntereses: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get(`api/Dominios/TagsInteresAlumno`).then(response => {
					(response.data.status == 0) ? commit('setInteresesCV', response.data.datos) : '';
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		requestProgramas: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get(`api/Dominios/ProgramasInformaticos`).then(response => {
					(response.data.status == 0) ? commit('setProgramas', response.data.datos) : '';
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestTitulacionesEmpresa: function ({ getters, commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get(`api/Dominios/titulaciones/${getters.getLanguage}`).then(response => {
					if (response.data.status == 0) {
						commit('setTitulaciones', response.data.datos);
						resolve(true);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestTitulacionesPorSedesSinDoctorado: function ({ getters, commit, dispatch }, {
			data = {
				"idSedes": []
			}
		} = {}) {
			axios.post(`api/Dominios/titulacionesPorSedesSinDoctorados/${getters.getLanguage}`, data).then(response => {
				///console.log(response)
				commit('setTitulaciones', response.data.datos);
			}).catch(function (error) {
				commit('setError', 500);
				dispatch('sendErrorServer', error.response);
			});

		},
		requestTitulacionesPorSedesDeAreasPracticas: function ({ getters, commit, dispatch }, {
			data = {
				"idSedes": []
			}
		} = {}) {
			axios.post(`api/Dominios/titulacionesPorSedesDeAreasDePracticas/${getters.getLanguage}`, data).then(response => {
				///console.log(response)
				commit('setTitulaciones', response.data.datos);
			}).catch(function (error) {
				commit('setError', 500);
				dispatch('sendErrorServer', error.response);
			});

		},
		requestMotivosRechazo: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get(`api/Dominios/tipoMotivoCambioEstadoCandidatura`).then(response => {
					if (response.data.status == 0) {
						commit('setMotivoRechazoPracticas', response.data.datos);
						resolve(true);
					}
				})
					.catch(function (error) { });
			});
		},
		createAniosForo({ commit }) {
			let init = 2010;
			let years = [];
			let finish = new Date().getFullYear();

			while (init <= finish) {
				years.push(init);
				init++;
			}

			commit('setAniosForo', years);

		},
		requestEmpresasPorProvincia: ({ commit, getters, dispatch }, idProvincia) => {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Dominios/centrosEducativosDeProvincia/${idProvincia}`).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos)
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		requestTiposContactos: ({ commit, getters, dispatch }, idProvincia) => {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Dominios/tiposContacoEmpresa`).then(response => {
					if (response.data.status == 0) {
						commit('setTiposContactoEmpres', response.data.datos);
						resolve(response.data.datos)
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		requestTiposIdentificacionDatosFacturacionCentro: ({ commit, state, getters, dispatch }) => {
			if(state.tiposIdentificacionDatosFacturacionCentro && state.tiposIdentificacionDatosFacturacionCentro.length > 0) {
				return;
			}
			return new Promise((resolve, reject) => {
				axios.get(`/api/Dominios/tiposDocumentoIdentificacion`).then(response => {
					if (response.data.status == 0) {
						state.tiposIdentificacionDatosFacturacionCentro = response.data.datos;
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
	},
	mutations: {
		setDominio: function (state, data) {
			state.dominios[data[0]] = data[1];
		},
		setDominiosList: function (state, data) {
			if (Object.values(data[1]).length != 0) {
				state.dominios[data[0]] = data[1];
			}
		},
		setDominios: function (state, data) {
			state.dominios = data;
		},
		setInteresesCV: function (state, data) {
			state.interesesCV = data;
		},
		setProgramas: function (state, data) {
			state.programas = Object.values(data || {}).filter(e => e != null);
		},
		setTitulaciones: function (state, data) {
			const values = Object.values(data || {}).filter(e => e != null && typeof e === 'object');
			state.titulacionesEmpresa = values.map(t => {
				const copy = { ...t };
				// Normalizamos las áreas: siempre un array
				if (Array.isArray(copy.areas)) {
					return copy;
				}
				if (copy.area != null) {
					copy.areas = [copy.area];
				} else if (!copy.areas) {
					copy.areas = [];
				}
				return copy;
			});
		},
		setTiposContactoEmpres: function (state, data) {
			state.tiposContactoEmpresa = data;
		},
		setMotivoRechazoPracticas: function (state, data) {
			state.motivosRechazo = data.sort((a, b) => a.descripcion > b.descripcion ? 1 : -1);
		},
		setAmbitosEstudio: function (state, data) {
			state.ambitos.ambitosEstudio = data;
		},
		setEspecialidadesAmbitoEstudio: function (state, data) {
			state.ambitos.especialidadesAmbitoEstudio[data[0]] = data[1];
		},
		setAniosForo(state, years) {
			state.aniosForo = years;
		}
	}
}

export default dominios;



// WEBPACK FOOTER //
// ./src/store/dominios.js